import * as constants from './constants';

const initialState = {
  allCoachStatuses: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const coachStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_COACH_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_COACH_STATUSES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allCoachStatuses: [...state.allCoachStatuses, action.data],
        isAdding: false,
      };
    case constants.CREATE_COACH_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER_COACH_STATUS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_COACH_STATUS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allCoachStatuses: action.data,
      };
    case constants.UPDATE_ORDER_COACH_STATUS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_COACH_STATUSES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_COACH_STATUSES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allCoachStatuses: action.data,
        isAdding: false,
      };
    case constants.FETCH_COACH_STATUSES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_COACH_STATUSES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_COACH_STATUSES_SUCCESS:
      const updated = state.allCoachStatuses.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allCoachStatuses: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_COACH_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_COACH_STATUSES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_COACH_STATUSES_SUCCESS:
      const updatedData = state.allCoachStatuses.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allCoachStatuses: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_COACH_STATUSES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default coachStatusReducer;
